// extracted by mini-css-extract-plugin
module.exports = {"icon":"Icon_icon__6gVey","writeIcon":"Icon_writeIcon__hpmAB"};